export const USER_LOGOUT = 'token/USER_LOGOUT';